import { useEffect, useState } from 'react';
import { singletonHook } from 'react-singleton-hook';
import {
  getSplatUserType,
  SplatUserType,
  UserProfile,
} from '@sunrun/sales-experience-shared';
import { AmplifyGet } from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import { useHybridToken } from './Auth';
import { logger } from './logger';
import { Mixpanel } from './Mixpanel';
import { rollbar } from './rollbar';

const useUserProfile = singletonHook(
  {},
  (): {
    splatUserType?: SplatUserType;
    userProfile?: UserProfile;
  } => {
    const [splatUserType, setSplatUserType] = useState<SplatUserType>();
    const [userProfile, setUserProfile] = useState<UserProfile>();
    const { hybridToken } = useHybridToken();
    useEffect(() => {
      if (hybridToken) {
        AmplifyGet<{ userProfile: UserProfile }>(
          'Get User Profile',
          'SalesExpDashboardApi',
          '/userProfile',
          {
            headers: {
              Authorization: `Bearer ${hybridToken}`,
            },
          },
          logger,
          {
            expectedErrorCodes: [401, 403],
          },
        )
          .then((response) => {
            setUserProfile(
              response.userProfile.sfdcContact ?? response.userProfile,
            );
            setSplatUserType(getSplatUserType(response.userProfile));
            const email =
              response.userProfile.sfdcContact?.email ??
              response.userProfile.email;
            Mixpanel.identify(email);
            rollbar.configure({
              payload: {
                person: {
                  id: email,
                  email,
                },
                profile: {
                  id: email,
                  email,
                },
                userProfile: {
                  ...response.userProfile,
                },
              },
            });
          })
          .catch(() => {
            // TODO: Fix under SPLAT1-7040
            // Do nothing
          });
      }
    }, [hybridToken]);
    return { splatUserType, userProfile };
  },
);

export { useUserProfile };
